import {ChangeDetectionStrategy, Component, effect, inject, viewChild} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {Store} from '@ngrx/store';
import {SeFeIconModule} from 'se-fe-icon';
import {SeFeModalButton, SeFeModalModule} from 'se-fe-modal';
import {
  CatalogFormModalComponent,
  CatalogFormValue,
} from '../../../common/components/catalog-form-modal/catalog-form-modal.component';
import {CatalogDetailActions} from '../store/catalog-detail.actions';
import {
  selectCatalogDetail,
  selectCatalogDetailUpdateError,
  selectCatalogDetailUpdateStatus,
  selectCatalogDetailUpdating,
} from '../store/catalog-detail.selectors';

@Component({
  selector: 'app-edit-catalog-modal',
  templateUrl: './edit-catalog-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CatalogFormModalComponent, SeFeIconModule, SeFeModalModule],
})
export class EditCatalogModalComponent {
  readonly catalogFormModal = viewChild.required<CatalogFormModalComponent>('catalogFormModal');

  private readonly store = inject(Store);

  readonly catalog = toSignal(this.store.select(selectCatalogDetail), {requireSync: true});
  readonly updating = toSignal(this.store.select(selectCatalogDetailUpdating), {requireSync: true});
  readonly updateError = toSignal(this.store.select(selectCatalogDetailUpdateError), {requireSync: true});
  readonly editButton: SeFeModalButton = {icon: true};

  private readonly updateStatus = toSignal(this.store.select(selectCatalogDetailUpdateStatus), {requireSync: true});

  constructor() {
    effect(() => {
      if (this.updateStatus() !== 'success') {
        return;
      }

      this.catalogFormModal().close();
      this.store.dispatch(CatalogDetailActions.resetUpdateStatus());
    });
  }

  open(trigger: unknown): void {
    this.store.dispatch(CatalogDetailActions.resetUpdateStatus());
    this.catalogFormModal().open(trigger);
  }

  updateCatalog(formValue: CatalogFormValue): void {
    this.store.dispatch(
      CatalogDetailActions.update({
        catalog: {
          ...this.catalog()!,
          ...formValue,
        },
      })
    );
  }
}
